import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../../hooks/useTitle";
import { withAuth } from "../../../../../components/HOC/withAuth";
import CardContainer from "../../../../../components/CustomUI/CardContainer";
import { SectionSpinner, SectionEmpty } from "../../shared/utils";
import { RP_DONUT_TEALS } from "../../shared/constants";
import ProductionReportShell from "../ProductionReportShell";
import GroupByChips from "../GroupByChips";
import { usePartProductionReport } from "../usePartProductionReport";

const ProductionByPartTrend = () => {
  useTitle("Rovion MES - Üretim Çizgi Grafiği");
  const {
    filters,
    machines,
    shifts,
    loading,
    derived,
    groupBy,
    setGroupBy,
    fetchData,
    toasts,
    dismissToast,
  } = usePartProductionReport();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!derived) return <SectionEmpty />;
    const { dateKeys, timelineSeries } = derived;
    if (dateKeys.length < 2 || !timelineSeries.length)
      return <SectionEmpty msg="Trend için yeterli veri yok." />;

    return (
      <>
        {/* <GroupByChips groupBy={groupBy} onChange={setGroupBy} /> */}
        <CardContainer title="Üretim Çizgi Grafiği">
          <ReactApexChart
            type="area"
            series={timelineSeries}
            options={{
              chart: {
                type: "area",
                stacked: false,
                toolbar: { show: false },
                fontFamily: "inherit",
                foreColor: "#334155",
              },
              colors: RP_DONUT_TEALS.slice(0, timelineSeries.length),
              fill: {
                type: "gradient",
                gradient: { opacityFrom: 0.35, opacityTo: 0.05 },
              },
              stroke: { width: 2, curve: "smooth" },
              xaxis: {
                categories: dateKeys,
                labels: { rotate: -45, style: { fontSize: "10px" } },
              },
              yaxis: {
                labels: { formatter: (v) => v.toLocaleString("tr-TR") },
              },
              legend: { position: "top" },
              dataLabels: { enabled: false },
              grid: { borderColor: "#f0f2f5" },
              tooltip: {
                shared: true,
                intersect: false,
                y: { formatter: (v) => v.toLocaleString("tr-TR") },
              },
            }}
            height={320}
          />
        </CardContainer>
      </>
    );
  };

  return (
    <ProductionReportShell
      title="Üretim Çizgi Grafiği"
      filters={filters}
      machines={machines}
      shifts={shifts}
      onApply={fetchData}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </ProductionReportShell>
  );
};

export default withAuth(ProductionByPartTrend);
